import { render, staticRenderFns } from "./BomTb.vue?vue&type=template&id=5a16aa21&"
import script from "./BomTb.vue?vue&type=script&lang=js&"
export * from "./BomTb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a16aa21')) {
      api.createRecord('5a16aa21', component.options)
    } else {
      api.reload('5a16aa21', component.options)
    }
    module.hot.accept("./BomTb.vue?vue&type=template&id=5a16aa21&", function () {
      api.rerender('5a16aa21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/production/jobcard/jobcard-view/components/BomTb.vue"
export default component.exports